import { exigirDefinicionCoherente } from '../formularios/definicion.js';
/**
 * CAS-E · Escala de Movilidad Acumulada · 0–6.
 *
 * Cumulated Ambulation Score oficial en castellano, adaptado a auto-reporte por
 * Fundación (correo del 07/08/2026: "CAS-E son 6 y no 5"). Tres actividades de 0
 * a 2: levantarse y acostarse en la cama, sentarse y levantarse de una silla, y
 * caminar dentro de casa. La adaptación FAC 0–5 que circulaba antes —y su código
 * `marcha-fac-sr`— quedó retirada (enmienda ADR-008 del 2026-08-11).
 *
 * **Semántica de los puntos, del manual del instrumento:** 2 es independiente,
 * sin guía verbal ni ayuda física; 1 es con guía verbal o ayuda física de una o
 * más personas; 0 es incapaz incluso con ayuda. Los dispositivos de apoyo
 * terapéuticos están permitidos en los tres niveles: usar andador no baja el
 * puntaje, necesitar a alguien sí.
 *
 * **Sin skip-logic**: las tres preguntas se responden siempre
 * (`dev/fuentes-fundacion/Escalas/cas-e.png`). La actividad de escaleras del CAS
 * intrahospitalario no se pregunta: es opcional en el manual, no suma al total y
 * el árbol de Fundación no la incluye.
 *
 * La redacción de las opciones es la del árbol de Fundación, textual.
 */
export const FORMULARIO_CAS_E = exigirDefinicionCoherente({
    id: 'cas-e',
    clase: 'escala',
    instrumento: 'cas_e',
    titulo: 'Movilidad en el día a día',
    version: '1.0.0',
    estado: 'active',
    preguntas: [
        {
            id: 'cama',
            texto: '¿Podés acostarte y salir de la cama solo o necesitás ayuda?',
            campo: {
                tipo: 'opcion',
                opciones: [
                    { codigo: 'solo', etiqueta: 'No necesito ayuda, lo puedo hacer solo', puntos: 2 },
                    { codigo: 'con-ayuda', etiqueta: 'Necesito ayuda', puntos: 1 },
                    { codigo: 'no-puede', etiqueta: 'No puedo salir de la cama ni con ayuda', puntos: 0 },
                ],
            },
            presentacion: { modo: 'lista' },
            opcional: false,
        },
        {
            id: 'silla',
            texto: '¿Podés sentarte y levantarte de una silla?',
            campo: {
                tipo: 'opcion',
                opciones: [
                    { codigo: 'solo', etiqueta: 'Puedo hacerlo sin ayuda', puntos: 2 },
                    { codigo: 'con-ayuda', etiqueta: 'Necesito ayuda', puntos: 1 },
                    { codigo: 'no-puede', etiqueta: 'No puedo hacerlo, aún con ayuda', puntos: 0 },
                ],
            },
            presentacion: { modo: 'lista' },
            opcional: false,
        },
        {
            id: 'caminar',
            texto: '¿Caminás dentro de tu casa con o sin dispositivos terapéuticos?',
            campo: {
                tipo: 'opcion',
                opciones: [
                    { codigo: 'solo', etiqueta: 'Sí, puedo hacerlo sin ayuda', puntos: 2 },
                    { codigo: 'con-ayuda', etiqueta: 'Lo hago, pero necesito ayuda', puntos: 1 },
                    { codigo: 'no-puede', etiqueta: 'No puedo hacerlo, aún con ayuda', puntos: 0 },
                ],
            },
            presentacion: { modo: 'lista' },
            opcional: false,
        },
    ],
});
/** Las tres actividades, en orden. */
export const ACTIVIDADES_CAS_E = ['cama', 'silla', 'caminar'];
//# sourceMappingURL=cas-e.js.map